// extracted by mini-css-extract-plugin
export var root = "TextMedia-module--root--2V1fG";
export var block = "TextMedia-module--block--2riRd";
export var row = "TextMedia-module--row--Kp4_x";
export var image = "TextMedia-module--image--2gjih";
export var text = "TextMedia-module--text--2LK0d";
export var icon = "TextMedia-module--icon--iLgyM";
export var icon1 = "TextMedia-module--icon1--1Iyo4";
export var icon2 = "TextMedia-module--icon2--KEgN4";
export var icon3 = "TextMedia-module--icon3--2GlVZ";